import uuid from "uuid";

export default class InvoiceItem {
  id: string = uuid();
  unitName: string = "";
  expenseCategoryId: number = 0;
  unitType: string = "";
  unitPrice: number = 0;
  amount: number = 0;
  totalPrice: number = 0;
  memo: string = "";
  items: InvoiceItem[] = [];
  estimateRowId: number = 0;
  isFromActualResult?: boolean = false;
}
